import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hosteleria',
  templateUrl: './hosteleria.component.html',
  styleUrls: ['./hosteleria.component.scss']
})
export class HosteleriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
